/**
 * Workspace Service REST API
 *
 * Contact: ContactRequests@enverus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { Workspace } from '../model/workspace';
// @ts-ignore
import { WorkspaceCreate } from '../model/workspaceCreate';
// @ts-ignore
import { WorkspaceList } from '../model/workspaceList';
// @ts-ignore
import { WorkspaceTransfer } from '../model/workspaceTransfer';
// @ts-ignore
import { WorkspaceUpdate } from '../model/workspaceUpdate';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { WorkspacesAPIConfiguration } from '../configuration';
import { BaseService } from '../api.base.service';
import {
    PublicWorkspaceControllerServiceInterface,
    ChangePublicWorkspaceTypeRequestParams,
    ClonePublicWorkspaceRequestParams,
    CreatePublicWorkspaceRequestParams,
    DeletePublicWorkspaceRequestParams,
    ExportPublicWorkspaceRequestParams,
    GetPublicWorkspaceRequestParams,
    GetPublicWorkspacesRequestParams,
    ImportPublicWorkspaceRequestParams,
    UpdatePublicWorkspaceRequestParams
} from './publicWorkspaceController.serviceInterface';

@Injectable({
    providedIn: 'root'
})
export class PublicWorkspaceControllerService extends BaseService implements PublicWorkspaceControllerServiceInterface {
    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string | string[],
        @Optional() configuration?: WorkspacesAPIConfiguration
    ) {
        super(basePath, configuration);
    }

    /**
     * Change Workspace type
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changePublicWorkspaceType(
        requestParameters: ChangePublicWorkspaceTypeRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<Workspace>;
    public changePublicWorkspaceType(
        requestParameters: ChangePublicWorkspaceTypeRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<Workspace>>;
    public changePublicWorkspaceType(
        requestParameters: ChangePublicWorkspaceTypeRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<Workspace>>;
    public changePublicWorkspaceType(
        requestParameters: ChangePublicWorkspaceTypeRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling changePublicWorkspaceType.');
        }
        const type = requestParameters?.type;

        let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>type, 'type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/workspaces/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/changeType`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Workspace>('put', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            params: localVarQueryParameters,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Clone workspace
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clonePublicWorkspace(
        requestParameters: ClonePublicWorkspaceRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<Workspace>;
    public clonePublicWorkspace(
        requestParameters: ClonePublicWorkspaceRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<Workspace>>;
    public clonePublicWorkspace(
        requestParameters: ClonePublicWorkspaceRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<Workspace>>;
    public clonePublicWorkspace(
        requestParameters: ClonePublicWorkspaceRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling clonePublicWorkspace.');
        }
        const workspaceCreate = requestParameters?.workspaceCreate;

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/workspaces/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/clone`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Workspace>('post', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            body: workspaceCreate,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Create workspace
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createPublicWorkspace(
        requestParameters: CreatePublicWorkspaceRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<WorkspaceList>;
    public createPublicWorkspace(
        requestParameters: CreatePublicWorkspaceRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<WorkspaceList>>;
    public createPublicWorkspace(
        requestParameters: CreatePublicWorkspaceRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<WorkspaceList>>;
    public createPublicWorkspace(
        requestParameters: CreatePublicWorkspaceRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const workspaceCreate = requestParameters?.workspaceCreate;
        if (workspaceCreate === null || workspaceCreate === undefined) {
            throw new Error('Required parameter workspaceCreate was null or undefined when calling createPublicWorkspace.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/workspaces`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<WorkspaceList>('post', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            body: workspaceCreate,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Delete workspace
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deletePublicWorkspace(
        requestParameters: DeletePublicWorkspaceRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<any>;
    public deletePublicWorkspace(
        requestParameters: DeletePublicWorkspaceRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<any>>;
    public deletePublicWorkspace(
        requestParameters: DeletePublicWorkspaceRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<any>>;
    public deletePublicWorkspace(
        requestParameters: DeletePublicWorkspaceRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deletePublicWorkspace.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/workspaces/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Export full workspace
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportPublicWorkspace(
        requestParameters: ExportPublicWorkspaceRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<WorkspaceTransfer>;
    public exportPublicWorkspace(
        requestParameters: ExportPublicWorkspaceRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<WorkspaceTransfer>>;
    public exportPublicWorkspace(
        requestParameters: ExportPublicWorkspaceRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<WorkspaceTransfer>>;
    public exportPublicWorkspace(
        requestParameters: ExportPublicWorkspaceRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling exportPublicWorkspace.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/workspaces/export/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<WorkspaceTransfer>('get', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Get full workspace info
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPublicWorkspace(
        requestParameters: GetPublicWorkspaceRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<Workspace>;
    public getPublicWorkspace(
        requestParameters: GetPublicWorkspaceRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<Workspace>>;
    public getPublicWorkspace(
        requestParameters: GetPublicWorkspaceRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<Workspace>>;
    public getPublicWorkspace(
        requestParameters: GetPublicWorkspaceRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getPublicWorkspace.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/workspaces/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Workspace>('get', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Get workspaces
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPublicWorkspaces(
        requestParameters?: GetPublicWorkspacesRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<Array<WorkspaceList>>;
    public getPublicWorkspaces(
        requestParameters?: GetPublicWorkspacesRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<Array<WorkspaceList>>>;
    public getPublicWorkspaces(
        requestParameters?: GetPublicWorkspacesRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<Array<WorkspaceList>>>;
    public getPublicWorkspaces(
        requestParameters?: GetPublicWorkspacesRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const persona = requestParameters?.persona;
        const commodity = requestParameters?.commodity;
        const region = requestParameters?.region;
        const provider = requestParameters?.provider;

        let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>persona, 'persona');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>commodity, 'commodity');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>region, 'region');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>provider, 'provider');

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/workspaces`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<WorkspaceList>>('get', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            params: localVarQueryParameters,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Import full workspace
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importPublicWorkspace(
        requestParameters: ImportPublicWorkspaceRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<{ [key: string]: string }>;
    public importPublicWorkspace(
        requestParameters: ImportPublicWorkspaceRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<{ [key: string]: string }>>;
    public importPublicWorkspace(
        requestParameters: ImportPublicWorkspaceRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<{ [key: string]: string }>>;
    public importPublicWorkspace(
        requestParameters: ImportPublicWorkspaceRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const workspaceTransfer = requestParameters?.workspaceTransfer;
        if (workspaceTransfer === null || workspaceTransfer === undefined) {
            throw new Error('Required parameter workspaceTransfer was null or undefined when calling importPublicWorkspace.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/workspaces/import`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<{ [key: string]: string }>('post', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            body: workspaceTransfer,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Update workspace
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePublicWorkspace(
        requestParameters: UpdatePublicWorkspaceRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<WorkspaceList>;
    public updatePublicWorkspace(
        requestParameters: UpdatePublicWorkspaceRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<WorkspaceList>>;
    public updatePublicWorkspace(
        requestParameters: UpdatePublicWorkspaceRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<WorkspaceList>>;
    public updatePublicWorkspace(
        requestParameters: UpdatePublicWorkspaceRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updatePublicWorkspace.');
        }
        const workspaceUpdate = requestParameters?.workspaceUpdate;
        if (workspaceUpdate === null || workspaceUpdate === undefined) {
            throw new Error('Required parameter workspaceUpdate was null or undefined when calling updatePublicWorkspace.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/workspaces/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<WorkspaceList>('put', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            body: workspaceUpdate,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }
}
